import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-turns-parameters-locations-card',
  templateUrl: './turns-parameters-locations-card.component.html',
  styleUrls: ['./turns-parameters-locations-card.component.scss']
})
export class TurnsParametersLocationsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount: any;
  disableCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('locations-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('locations-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.filter((location) => location.Active === true).length;
      this.disableCount = this.data.filter((location) => location.Active === false).length;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.disableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('locations-counts-spinner');
    }
  }
}
